import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
}), 'PauseSharp');